export const PAYMENT_TYPE_API_REQUEST="PAYMENT_TYPE/PAYMENT_API_REQUEST";
export const PAYMENT_TYPE_API_SUCCESS="PAYMENT_TYPE/PAYMENT_API_SUCCESS";
export const PAYMENT_TYPE_API_FAILED="PAYMENT_TYPE/PAYMENT_API_FAILED";
